/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, getParams, urlEncodeQueryFilters } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';
import FacebookLogin from 'react-facebook-login';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './Splash.css';
import WhereField from './partials/WhereField';
import OmniField from './partials/OmniField';
import LeaderboardStats from './partials/LeaderboardStats';
import Ranking from './partials/Ranking';
import RoomMap from './partials/RoomMap';
import Loading from './partials/Loading';


import {
  getStats,
  getGeoIp,
  getLeaderboard,
  getRanking,
  getNewsFeed,
} from '../actions';


class NewsFeed extends Component {
  state = {};

  componentDidMount() {
    this.setState({ loading: true });
    this.props.getNewsFeed()
      .then(resp => {
        console.log('newsfeed resp', resp);
        this.setState({ loading: false, feed: resp.obj.items });
      });
  }

  renderEscape(escape) {
    let img = escape.photo || escape.room.defaultImg;
    let outcome = escape.didEscape ? 'ESCAPED' : 'did NOT escape';

    return (
      <div>
        <div>{escape.id}</div>
        {img && <div><img src={img} /></div>}
        <div>{moment(escape.timeCreated).fromNow()}</div>
        <div><b>{escape.username}</b> attempted <b>{escape.room.name}</b> and <b>{outcome}</b></div>
      </div>
    );
  }

  renderFeed() {
    let feed = this.state.feed;
    if (!feed) return <Loading />;

    let i = 0;
    let nodes = feed.map(item => {
      return (
        <div key={item.type + ':' + item.data.id}>
          {item.type == 'escape' && this.renderEscape(item.data)}
        </div>
      );
    });

    return (
      <div>
        {nodes}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderFeed()}
      </div>
    );
  }
}

NewsFeed = connect(
  (state) => { return {} },
  (dispatch) => { return mapDispatch(dispatch, { getNewsFeed }) },
)(NewsFeed);


class CityList extends Component {
  render() {
    let cities = this.props.cities;
    cities.sort((a, b) => a.name.localeCompare(b.name));
    let nodes = cities.map(city => {
      return (
        <div key={city.id} className="city">
          <Link to={'/c/' + city.slug}>{city.name}
          {city.province && <span>, {city.province}</span>}</Link>
        </div>
      );
    });

    return (
      <div className="cities">
        {nodes}
      </div>
    );
  }
}


class ProvinceList extends Component {
  render() {
    let cities = this.props.cities;

    let citiesByProvince = {};
    for (let city of cities) {
      let province = city.province;
      if (!citiesByProvince[province]) {
        citiesByProvince[province] = [];
      }
      citiesByProvince[province].push(city);
    }

    let nodes = [[], [], []];
    let provinces = Object.keys(citiesByProvince);
    provinces.sort((a, b) => a.localeCompare(b));
    // for (let province of provinces) {
    for (let i = 0; i < provinces.length; i++) {
      let province = provinces[i];
      let provinceName = citiesByProvince[province][0].provinceName;
      let idx = 0;
      if (i > provinces.length / 3) {
        idx = 1;
      }
      if (i > provinces.length * (2/3)) {
        idx = 2;
      }
      console.log('idx', idx);
      nodes[idx].push(
        <div className="province">
          <div className="province-name">{provinceName}</div>
          <CityList
            key={province}
            cities={citiesByProvince[province]}
          />
        </div>
      );
    }

    return (
      <div className="provinces">
        <div className="province-list">{nodes[0]}</div>
        <div className="province-list">{nodes[1]}</div>
        <div className="province-list">{nodes[2]}</div>
      </div>
    );
  }
}


class Splash extends OzComponent {

  static need = [
    ['stats', getStats, () => { return [null, { silent: true }] }],
    // ['leaderboard', getLeaderboard],
    // ['ranking', getRanking, () => { return [null, {}, { limit: 3 }] }],
  ]

  constructor(props) {
    super(props);
    this.state = {
      date: moment(),
    };
    let params = getParams();
    if (params.omni) {
      this.state.omni = true;
    }
    this.state.omni = true;
  }

  componentDidMount() {
    this.props.getGeoIp(null, { silent: true })
      .then(resp => {
        let where = {
          name: resp.obj.city + ', ' + resp.obj.regionCode,
          lat: resp.obj.lat,
          lng: resp.obj.lng,
        };
        this.setState({ prefill: where.name, where });
      });
  }

  search(e) {
    if (e) e.preventDefault();
    let where = this.state.where;
    console.log('search with where:', where);
    let filters = [{ key: 'date', value: this.state.date.format('YYYY-MM-DD')}];
    let enc = urlEncodeQueryFilters(filters);
    navTo('/s?city=' + encodeURIComponent(where.name) + '&filters=' + enc);
  }

  setWhere(where, cb=null) {
    console.log('where:', where);
    this.setState(
      { where },
      () => {
        if (cb) cb();
      });
  }

  renderLeaderboard() {
    let lb = this.props.leaderboard;
    if (!lb) return;
    return (
      <div>
        <LeaderboardStats leaderboard={lb} topN={3} />
      </div>
    );
  }

  renderRanking() {
    let ranking = this.props.ranking;
    if (!ranking) return;

    return (
      <div className="splash-ranking">
        <Ranking
          headless
          isRollup
          reviews={{items: ranking.ranking}}
          onRefresh={(params) => this.refresh(params)}
        />
      </div>
    )
  }

  omniSelect(type, value) {
    console.log('omni select', type, value);
    let url;
    let date = this.state.date.format('YYYY-MM-DD');
    if (type == 'city') {
      url = '/s?city=' + encodeURIComponent(value.description) + '&date=' + date;
    } else if (type == 'room') {
      url = '/r/' + value.slug + '/' + value.id;
    } else if (type == 'location') {
      url = '/s?city=' + encodeURIComponent(value.cityName) + '&date=' + date + '&company=' + encodeURIComponent(value.company);
    }
    navTo(url);
  }

  render() {
    let stats = this.props.stats || { counts: {}, cities: []};

    let isToday = this.state.date.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD');
    let showToday = isToday && !this.state.focused;

    let geoIp = this.props.geoIp || {};

    // FB.getLoginStatus(function(response) {
    //   console.log('facebook:', response);
    // });

    return (
      <Wrapper className="Splash">

        <div className="top-blurb">Find <b>escape rooms</b> near you</div>
        <Form className="search" onSubmit={(e) => this.search(e)}>
          <div className="where OmniField">
            {this.state.omni && <OmniField
              key="omni"
              prefill={this.state.prefill}
            />}

            {!this.state.omni && <WhereField
              key="where"
              prefill={this.state.prefill}
              onChange={(where) => this.setWhere(where)}
              onSelect={(where) => {
                        this.setWhere(where, () => this.search());
                        }}
                />}
          </div>
          <div className="date-button">
            <div className="date">
              {showToday && <div className="today" onClick={() => this.setState({ focused: true })}>
               Today <FontAwesome name="caret-down" />
               </div>}
              {!showToday && <SingleDatePicker
                date={this.state.date}
                onDateChange={date => this.setState({ date })}
                focused={this.state.focused}
                onFocusChange={({ focused }) => this.setState({ focused })}
                id="when"
                numberOfMonths={1}
                displayFormat="ddd M/D"
                noBorder={true}
              />}
            </div>
            <div className="button">
              <Button type="submit" bsStyle="primary" bsSize="lg">Find Rooms</Button>
            </div>
          </div>
        </Form>

        {/*
        <div className="toprooms-promo">
          <div className="toprooms-blurb">
            <div className="blurb-header">Vote for Best Rooms</div>
            <div className="blurb-copy">Cast your vote for the <b>BEST ESCAPE ROOMS</b> of <b>2019</b>. Rooms with the top ratings will receive awards and special highlights on the site to help everyone discover top notch escape experiences.<br/><br/>Submit your ratings by <b>January 15th</b> to make your voice heard.</div>
          </div>
          <div className="toprooms-cta-wrapper">
            <div className="toprooms-cta">
              <Link to="/vote">Vote For Best Rooms</Link>
            </div>
          </div>
            </div>
          */}

        <br/>

        <div className="track-promo">
          <div className="track-blurb">
            <div className="blurb-header">Enthusiast? Track your escapes!</div>

            <div className="blurb-copy">Create a profile to track your escapes, discuss rooms, rank your favorites, and more - all in one place!</div>
          </div>
          <div className="track-cta-wrapper">
            <div className="track-cta">
              <Link to="/track">Track Your Escapes</Link>
            </div>
          </div>
        </div>

        <div className="info">
          <div className="sub-blurb">Search hundreds of escape rooms with one click.</div>
          <div className="info-stats">
            <div className="stat"><span className="number">{numberWithCommas(stats.counts.cities)}</span> cities</div>
            {/* <div className="stat"><span className="number">{numberWithCommas(stats.counts.locations)}</span> locations</div> */}
            <div className="stat"><span className="number">{numberWithCommas(stats.counts.rooms)}</span> rooms</div>
            <div className="stat"><span className="number">{numberWithCommas(stats.counts.timeSlots)}</span> time slots</div>
          </div>
        </div>

        {/* <NewsFeed /> */}

        <RoomMap
          lat={this.state.lat || geoIp.lat}
          lng={this.state.lng || geoIp.lng}
          updateSelf
          initDelay={2000}
        />

        {/*
        <div className="info">
          <div className="sub-blurb">See the top ranked rooms in your city and worldwide!</div>
        </div>
        {this.renderRanking()}
        <div className="full-link">
          <Link to="/top"><Button bsStyle="primary" bsSize="lg">See Top Rooms</Button></Link>
        </div>
        */}

        {/*
        <div className="info">
          <div className="sub-blurb">See how you rank on our global leaderboard!</div>
        </div>
        {this.renderLeaderboard()}
        <div className="full-link">
          <Link to="/leaderboard"><Button bsStyle="primary" bsSize="lg">See Full Leaderboard</Button></Link>
        </div>
        */}

        <div className="geo-blurb">
          <p>We list escape rooms and their time slots in dozens of countries and hundreds of cities.</p>
          <Link to={'/geo'}><Button>See Full Country List</Button></Link>
        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    stats: state.get.stats,
    geoIp: state.get.geoIp,
    leaderboard: state.get.leaderboard,
    ranking: state.get.ranking,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getStats,
    getGeoIp,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Splash);



/** WEBPACK FOOTER **
 ** ./src/components/Splash.js
 **/